import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Table } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '../../../helper'
import { Taxes } from '@hmp/models/taxes.model'

const log = new Logger('TaxesService')

/**
 * Đây là services dành cho Promotions
 */

@Injectable({ providedIn: 'root' })
export class TaxesService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng cho User
   */
  private _apiPath = {
    list: 'taxes/taxes_entity',
    detail: 'taxes/taxes_entity',
    set_type_tax_price: 'taxes/taxes_entity/set_type_tax_price_entity',
    change_status_tax: 'business/taxes_entity/switch_on_off_tax_entity',
    taxes_stores: 'business/business_restaurants',
  }

  /**
   * Lấy tất cả Promotions đang available
   * @param params Danh sách tham số muốn truyền.
   * ex: { 'pagesize': 10, 'page':1 }
   */
  getAll(params?: any): Observable<any> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'parameters[taxes_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        return data
      })
    )
  }

  edit(res: Taxes): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.tid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  create(res: Taxes): Observable<any> {
    res.tid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        return data
      })
    )
  }

  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }

  getDetail(id: string): Observable<Taxes> {
    return this.apiService.get<Taxes>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }

  setType(res): Observable<any> {
    return this.apiService.post(this._apiPath.set_type_tax_price, res).pipe(
      map(data => {
        return data
      })
    )
  }
  changeStatusTax(res): Observable<any> {
    return this.apiService.post(this._apiPath.change_status_tax, res).pipe(
      map(data => {
        return data
      })
    )
  }
  getTaxesStore(params?: any): Observable<any> {
    let pa = new HttpParams()
      .set('bid', this.storage.getActiveLocalBusinessID())
      .set('select_box', '1')
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }

    return this.apiService.get<any>(this._apiPath.taxes_stores, pa).pipe(
      map(data => {
        return data
      })
    )
  }
}
